// extracted by mini-css-extract-plugin
export default {"tag":"MGTag_tag__ye-br","label":"MGTag_label__4zPIK","close":"MGTag_close__uGQtw"};